export default __webpack_public_path__ + "static/media/prana09.a3cbc9f2.JPG";